import "./adminSelectEdit.css";
import SetNavbarForm from "../dashboard/navbar_form/SetNavbarForm";
import { useState } from "react";

export default function AdminSelectEdit({website, theme}) {
    const [currentChild, setCurrentChild] = useState(null);
    const [selectValue, setSelectValue] = useState("");
    const options = [
        {
            text:"שנה את כפתורי הניווט",
            child:<SetNavbarForm website={website}/>
        }
    ]
    const deployOptions = ()=>{
        return options.map((opt, inx)=>{
            return <option key={`adminSelectEdit_option_inx_${inx}`} value={opt.text} onClick={()=>{setCurrentChild(opt.child)}}>{opt.text}</option>
        })
    }
    const handleChange = (e) => {
        const val = e.target.value;
        setSelectValue(val);

        const selectedOption = options.find(opt => opt.text === val);
        setCurrentChild(selectedOption?.child);
    };
    return (
        <div className="selectEdit_container">
            <select value={selectValue} onChange={(e)=>{handleChange(e)}} className="selectEdit_dropdown">
                <option value="" hidden disabled>בחר אחת מהאפשרויות..</option>
                {deployOptions()}
            </select>
            <div style={{color:theme?.primary_color}}>{currentChild}</div>
        </div>
    )
}
